module.exports = __webpack_public_path__ + "static/media/goodluck.5724a44c.mp3";